import { Pipe, PipeTransform } from '@angular/core';
import { CalendarSource } from '../data/calendar-source.interface';

@Pipe({
  standalone: false,
  name: 'containsSource',
})
export class ContainsSourcePipe implements PipeTransform {
  transform(sources: CalendarSource[], type: any): CalendarSource {
    const result = sources.find((source) => source.type === type);

    if (result) {
      return result;
    } else {
      return {
        type,
        source: 'none',
        date: null,
      };
    }
  }
}
